export const MENS_ALL_PRODUCT_SUCCESS = 'MENS_ALL_PRODUCT_SUCCESS';
export const WOMENS_ALL_PRODUCT_SUCCESS = 'WOMENS_ALL_PRODUCT_SUCCESS';
export const PRODUCT_REQUEST = 'PRODUCT_REQUEST';
export const PRODUCT_FAILURE = 'PRODUCT_FAILURE';
export const CART_COUNT = 'CART_COUNT';